import { useState } from 'react';
import { Menu, X, MessageCircle } from 'lucide-react';
import { BRAND, NAV_LINKS, scrollToId } from '../config/site';
import BrandLogo from './BrandLogo';

export const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-navy/10 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between gap-1 px-4 sm:gap-4 sm:px-6 lg:px-8">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            setOpen(false);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          aria-label={`${BRAND.fullName} — back to top`}
          className="min-w-0 shrink-0"
        >
          <BrandLogo />
        </a>

        <nav className="hidden items-center gap-7 lg:flex" aria-label="Primary">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              className="text-sm font-medium text-charcoal transition-colors hover:text-electric"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={BRAND.smsHref}
            data-testid="nav-text-button"
            className="inline-flex items-center gap-2 rounded-full border border-navy/15 px-4 py-2.5 text-sm font-semibold text-navy transition-all hover:-translate-y-0.5 hover:border-electric hover:text-electric"
          >
            <MessageCircle size={15} />
            Text Us
          </a>
          <button
            type="button"
            data-testid="nav-quote-button"
            onClick={() => go('quote')}
            className="rounded-full bg-electric px-5 py-2.5 text-sm font-bold uppercase tracking-wide text-white transition-all hover:-translate-y-0.5 hover:bg-navy"
          >
            Get a Free Quote
          </button>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <button
            type="button"
            data-testid="nav-quote-button-mobile"
            onClick={() => go('quote')}
            className="rounded-full bg-electric px-4 py-2.5 text-xs font-bold uppercase tracking-wide text-white transition-colors hover:bg-navy sm:px-5"
          >
            Free Quote
          </button>
          <button
            type="button"
            data-testid="nav-menu-toggle"
            aria-label={open ? 'Close menu' : 'Open menu'}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="grid h-10 w-10 place-items-center rounded-full border border-navy/15 text-navy"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="border-t border-navy/10 bg-white px-4 pb-6 pt-2 lg:hidden" aria-label="Mobile">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={(e) => {
                e.preventDefault();
                go(l.id);
              }}
              className="block border-b border-navy/5 py-3.5 text-base font-semibold text-navy"
            >
              {l.label}
            </a>
          ))}
          <div className="mt-5 flex flex-col gap-3">
            <button
              type="button"
              data-testid="mobile-menu-quote-button"
              onClick={() => go('quote')}
              className="w-full rounded-full bg-electric py-3.5 text-sm font-bold uppercase tracking-wide text-white"
            >
              Get a Free Quote
            </button>
            <a
              href={BRAND.smsHref}
              data-testid="mobile-menu-text-button"
              className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-navy/15 py-3.5 text-sm font-bold text-navy"
            >
              <MessageCircle size={15} />
              Text Us
            </a>
          </div>
        </nav>
      )}
    </header>
  );
};

export default Header;
